import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCateringMealsOrderDetails, getOrderDetails, resetCheckoutEbtState, saveOrderAnalytics } from "redux/actions";
import { Link, useNavigate } from "react-router-dom";
import Moment from "moment";
import "./order-confirmation.scss";
import "./order-table.scss";
import { getLocalStorageValue, isKeyurSite, setLocalStorageValue } from "config/helper";
import useShippingLabel from 'hooks/useShippingLabel';
import { PROCESSING_DATE_AND_TIME } from 'config/constant';

const OrderConfirmation = () => {
const dispatch = useDispatch();
  const [readyOrderDetail, setReadyOrderDetails] = useState(false);
  const { savePlaceOrder, ebtPaymentResponse, paymentTransactionId, paymentTransactionType } = useSelector(({ checkout }) => checkout);
  const { orderdetailsData, orderdetailsDataLoading } = useSelector(({ customer }) => customer);
  const clientId = getLocalStorageValue("RSAclient-id");
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const memberNumber = getLocalStorageValue("member-number");
  const userToken = getLocalStorageValue("user-token");
  const navigate = useNavigate();

  const { shippingLabelLower } = useShippingLabel()

  function getSavePlaceOrder() {
    if (Object.keys(savePlaceOrder ?? {})?.length) {
      return savePlaceOrder;
    }

    const details = getLocalStorageValue("order-confirmation-details") ?? {};
    if (Object.keys(details)?.length) {
      return JSON.parse(details);
    }

    return {};
  }

  const savePlaceOrderDetail = getSavePlaceOrder()
  const {
    order_id,
    meal_order_id,
    order_number,
    customer_email,
    shipping_date,
    shipping_day,
    shipping_time,
    order_placed_on,
    customer_first_name,
    customer_last_name,
    transaction_id,
    shipping_method,
    pickup_location: {
      AddressLine1 = "",
      City = "",
      StateName = "",
      StoreEmail = "",
      StorePhoneNumber = "",
      ZipCode = "",
    } = {},
  } = savePlaceOrderDetail

  const headerSectionData = useSelector(({ common }) => common.commonDetailsData.header_section);
  const copyRightSectionData = useSelector(({ common }) => common.commonDetailsData.footer_section);

  useEffect(() => {
    if (Object.keys(savePlaceOrderDetail)?.length) {
      setLocalStorageValue("order-confirmation-details", JSON.stringify(savePlaceOrderDetail));
    } else {
      navigate("/");
    }

    return () => {
      localStorage.removeItem("order-confirmation-details");
    }
  }, [])

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: storeId,
      AppName: isUserLoggedIn ? "shop" : "",
      Version: isUserLoggedIn ? "1" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    setReadyOrderDetails(true);
    if (order_id) {
      body.order_id = order_id;
      dispatch(getOrderDetails(body));
    } else if (meal_order_id) {
      body.meal_order_id = meal_order_id;
      dispatch(getCateringMealsOrderDetails(body));
    }
  }, [dispatch, clientId, storeId, isUserLoggedIn, memberNumber, userToken, order_id, meal_order_id]);

  const formatToRFC3339 = (inputDate) => new Date(inputDate.replace(/-/g, "/")).toISOString();

  useEffect(() => {
    if (Object.keys(orderdetailsData)?.length && readyOrderDetail && !orderdetailsDataLoading) {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        member_number: orderdetailsData.member_number || "",
        order_id: order_id || "",
        order_date: formatToRFC3339(orderdetailsData?.order_placed_on) || "",
        items: orderdetailsData.order_item_list.map(item => ({
          upc: item.sku,
          qty: item.qty,
          unit_price: item.price,
          total_item_price_after_discount: item.final_total,
          discount_amount: item.coupon_discount
        }))
      };
      dispatch(saveOrderAnalytics(body));
    }
  }, [orderdetailsData, readyOrderDetail, orderdetailsDataLoading, dispatch, clientId, storeId, order_id]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("last_new_order_id");
      dispatch(resetCheckoutEbtState());
    };
  }, [dispatch]);

  const dateFormat = (inputDate, format, moment) => {
    if (!inputDate) return "";

    if (moment) {
      return Moment(inputDate).format("MM-DD-YYYY");
    } else {
      const date = new Date(inputDate);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      format = format.replace("MM", month.toString().padStart(2, "0"));

      if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
      } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
      }
      format = format.replace("dd", day.toString().padStart(2, "0"));

      return format;
    }
  };

  const formatPhoneNumber = (str) => {
    const cleaned = ("" + str).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : null;
  };

  const { ebt_card_balance_info, ebt_initiate_tran_id } = (ebtPaymentResponse && ebtPaymentResponse.data) || {};

  const pickupDate = clientId === "334" || isKeyurSite()
                     ? PROCESSING_DATE_AND_TIME
                     : "Pickup Date"

  return (
    <div className="order-confirmation-wrapper">
      <div className="order-confirmation">
        <div className="confirmation-header">
          <h2>Thank you for your order!</h2>
        </div>

        <table className="shop_table my_account_orders">
          <tbody className="confirmation-body">
            <tr className="order" style={{textAlign:"center"}}>
              <td className="order-number" data-title="" colSpan={6}>
                <img
                  src={headerSectionData.rsa_client_logo}
                  alt={headerSectionData.image_alt_text}
                  className="logo-width-100"
                />
              </td>
              {/* <td className="order-actions" data-title="" colSpan={3}>
                <img
                  src={copyRightSectionData.powered_by}
                  alt="PowerdByImage"
                />
              </td> */}
            </tr>

            <tr className="order">
              <td className="order-number" data-title="" colSpan={3}>
                <strong>
                  {customer_first_name} {customer_last_name},
                </strong>{" "}
                Your order has been received.
                <br />
                You will receive an email confirmation shortly on{" "}
                <strong> {customer_email}</strong>
              </td>
              <td className="order-actions" data-title="" colSpan={3}>
                <h4>{`Your ${shipping_method === "Delivery" ? shippingLabelLower : "Pickup"} Location:`}</h4>
                <p>
                  {AddressLine1}, {City}, {StateName},{" "}
                  {ZipCode}
                  <br />
                </p>
              </td>
            </tr>

            <tr className="order">
              <td className="order-number" data-title="" colSpan={3}>
                <p className="order-numer">
                  Order Placed{" "}
                  <strong>
                    {dateFormat(order_placed_on?.split(" ")?.[0], "MM-dd-yyyy")}
                  </strong>
                </p>
                <p className="order-number">
                  <strong>Order number is: {order_number}</strong>
                </p>
              </td>
              <td className="order-actions" data-title="" colSpan={3}>
                <h4>{pickupDate}</h4>
                <p>
                  {shipping_day},{" "}
                  {dateFormat(shipping_date, "MM-dd-yyyy", "moment")}
                  <br />
                  {shipping_time}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
         {(ebt_initiate_tran_id || ebt_card_balance_info || transaction_id || paymentTransactionId) && (
        <div className="payment-border">
        {ebt_initiate_tran_id && (
          <p>
            <strong>
              Your EBT Payment Transaction ID is : {ebt_initiate_tran_id}
            </strong>
          </p>
        )}
        {ebt_card_balance_info && <p>{ebt_card_balance_info}</p>}
        {transaction_id && (
          <p>Your Payment Transaction ID is : {transaction_id}</p>
        )}
        {paymentTransactionId && paymentTransactionType === "authorize.net" && (
          <p>Your Authorize Payment Transaction ID is : {paymentTransactionId}</p>
        )}
        {paymentTransactionId && paymentTransactionType === "stripe" && (
          <p>Your Stripe Payment Token ID is : {paymentTransactionId}</p>
        )}
        </div>
        )}
        <div className="confirmation-body">
          <span className="order-page-link">
            You can check status of this order in your&nbsp;
            <Link to={meal_order_id ? `/checkout-invoice/catering-meal/${meal_order_id}` : `/order-details/${order_id}`}> account.</Link>
          </span>
          <span className="email-us">
            Questions? Call {formatPhoneNumber(StorePhoneNumber)} or&nbsp;
          </span>
          <span className="email-us">
          Email us&nbsp;<a className="order-email" href={`mailto:${StoreEmail}`} target="_blank" rel="noreferrer">
            {" "}{StoreEmail}
          </a>
          </span>
          <span className="back-to-home-btn">
            <Link to="/">Back to home</Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
